import fetch from '../api/FetchInterceptor';
import type { PaginatedResponse, Response } from 'domain/Response';
import type { User } from 'domain/User';
import type { UserForm } from 'components/users-components/types';
import type { Id } from 'domain/Id';

export const makeGetUsersRequest = (query: string): PaginatedResponse<User> =>
  fetch.get(`/users${query}`);

export const makePostUserRequest = (form: UserForm): Response<User> => fetch.post(`/users`, form);

export const makeGetUserRequest = (id: Id): Response<User> => fetch.get(`/users/${id}/edit`);
export const makePutUserRequest = (id: Id, form: UserForm): Response<User> =>
  fetch.put(`/users/${id}`, form);

export const makeDeleteUserRequest = (id: Id): Response<void> => fetch.delete(`/users/${id}`);

export const makeGetMeRequest = (): Response<User> => fetch.get(`/me`);
